import { render, staticRenderFns } from "./limitbee.vue?vue&type=template&id=9d24b966&scoped=true&"
import script from "./limitbee.vue?vue&type=script&lang=js&"
export * from "./limitbee.vue?vue&type=script&lang=js&"
import style0 from "./limitbee.vue?vue&type=style&index=0&id=9d24b966&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d24b966",
  null
  
)

export default component.exports